import { call, put, takeLatest } from "redux-saga/effects";
import { postExam } from "../../../services/exam";
import {
  createExamStart,
  createExamSuccess,
  createExamFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { successNotifier } from "../../../utils/helpers";

export function* createExam({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postExam, data);
  const { success, raw, message, statusCode } = response;

  if (success) {
    yield put(createExamSuccess()); 
    successNotifier("Exam created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createExamFailure());
    networkErrorHandler(statusCode, message || raw.error);
  }
}

export default function* onCreateExam() {
  yield takeLatest(createExamStart.type, createExam);
}
